export type PreviewPosition = "right" | "top" | "hidden";

interface Props {
  title: string;
  isDirty: boolean;
  saving?: boolean;
  userName?: string;
  previewPosition?: PreviewPosition;
  canUndo?: boolean;
  canRedo?: boolean;
  onSave: () => void;
  onRun: () => void;
  onLeave?: () => void;
  onLogout?: () => void;
  onChangePreviewPosition?: (pos: PreviewPosition) => void;
  onUndo?: () => void;
  onRedo?: () => void;
  onPublish?: () => void;
}

export function Toolbar({
  title,
  isDirty,
  saving,
  userName,
  previewPosition,
  canUndo,
  canRedo,
  onSave,
  onRun,
  onLeave,
  onLogout,
  onChangePreviewPosition,
  onUndo,
  onRedo,
  onPublish,
}: Props) {
  return (
    <header className="toolbar">
      <div className="toolbar-title">
        {onLeave && (
          <button className="toolbar-back" onClick={onLeave} title="プロジェクト一覧へ">
            ←
          </button>
        )}
        <strong>Pix Studio</strong>
        <span className="toolbar-project">/ {title}</span>
        {saving ? (
          <span className="toolbar-saving" title="保存中…">⟳</span>
        ) : isDirty ? (
          <span className="toolbar-dirty" title="未保存(自動保存待ち)">●</span>
        ) : (
          <span className="toolbar-saved" title="保存済み">✓</span>
        )}
      </div>
      <div className="toolbar-actions">
        {previewPosition && onChangePreviewPosition && (
          <div className="seg" title="プレビュー位置">
            <button
              className={"seg-btn" + (previewPosition === "right" ? " active" : "")}
              onClick={() => onChangePreviewPosition("right")}
              title="右に表示"
            >
              ▷
            </button>
            <button
              className={"seg-btn" + (previewPosition === "top" ? " active" : "")}
              onClick={() => onChangePreviewPosition("top")}
              title="上に表示"
            >
              △
            </button>
            <button
              className={"seg-btn" + (previewPosition === "hidden" ? " active" : "")}
              onClick={() => onChangePreviewPosition("hidden")}
              title="非表示"
            >
              ✕
            </button>
          </div>
        )}
        {(onUndo || onRedo) && (
          <div className="seg" title="アンドゥ / リドゥ">
            <button
              className="seg-btn"
              onClick={onUndo}
              disabled={!canUndo}
              title="アンドゥ (Ctrl+Z)"
            >
              ↶
            </button>
            <button
              className="seg-btn"
              onClick={onRedo}
              disabled={!canRedo}
              title="リドゥ (Ctrl+Y)"
            >
              ↷
            </button>
          </div>
        )}
        <button
          className="btn btn-secondary"
          onClick={onSave}
          disabled={saving}
          title="保存 (Ctrl+S)"
        >
          {saving ? "..." : "保存"}
        </button>
        <button className="btn btn-primary" onClick={onRun} title="プレビュー実行 (F5)">
          ▶ 実行
        </button>
        {onPublish && (
          <button className="btn btn-accent" onClick={onPublish} title="Portal に公開">
            ↑ 公開
          </button>
        )}
        {userName && (
          <span className="toolbar-user">
            {userName}
            {onLogout && (
              <button className="link-btn" onClick={onLogout} title="ログアウト">
                ⏏
              </button>
            )}
          </span>
        )}
      </div>
    </header>
  );
}
